var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"duration":800,"name":"fade"}},[(_vm.show)?_c('small',{class:'text-' + _vm.type},[_vm._t("default",[_vm._v(" ")])],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }